import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { screenReaderOnlyStyle } from 'style/config';

function VisuallyHidden({ is = 'div', ...props }) {
    const Component = is;

    return (
        <Component
            css={screenReaderOnlyStyle}
            {...props}
        />
    );
}

export default wrapFunctionalComponent(VisuallyHidden, 'VisuallyHidden');
